/**
 * [ File :: G_ImagePath.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/image/G_ImagePath.js
 * @설명 : 패스객체
 * @진행 : 종료
 * @주의 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import G_ImageGrid from 'canvas/grid/dev/child/image/G_ImageGrid';

const G_ImagePath = (function() {

	return class extends G_ImageGrid {
		constructor(obj) {
			super(obj);

            if(obj.color) this.color = obj.color;

			// [S] command
			if(obj.command) this._command = obj.command;

			// [*] 'path' type은 객체로써 역할을 하지 않습니다.
			delete this.CODMOS.WORLD.LIST.obj[this._id];
		}

		// @DES :: command {str} - 패스에 적용된 명령어
		get command() { return _command.get(this); }
		// set command(c) { _command.set(this, c); }

		/**
		 * [ Function (protected) :: _playCommand ]
		 *
		 * @DES :: 저장된 커멘트 실행시키기
		 * @IN1 :: hero {obj}
		 * @IP2 :: onCanvasEvent {func}
		 * @IP3 :: userEvent {func}
		 * @OUT ::
		 * @S.E ::
		 */
		_playCommand(hero, onCanvasEvent, userEvent) {
			// /*[T]*/ console.log('_playCommand');

			if(this._command) {
				hero._moveStatus = false;  // 행동헤제
				hero[this._command](userEvent);
			}
			else if(onCanvasEvent) onCanvasEvent();
		}

	}
}());

export default G_ImagePath;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/image/G_ImagePath.js